import { CacheDataToRefresh } from "../subject-behaviour/CommonRxjsService";

import { store } from "../../../store/store";
import { getImagePath, getServerID, isObjectNotEmpty, objectContainAllKeys } from "../CommonUtils";

import { ServiceEndpoints } from "../../constants/AppConstants";

import RefreshCacheAction from "../webapp-services/RefreshCache";

export function getSelectedChemistStoreId(reduxState) {
    let pharmacyId = 0;
    if (localStorage.getItem('storeProfileLoaded')) {
        let profileDeeplinkData = localStorage.getItem('profileDeeplinkData');
        if (profileDeeplinkData) {
            pharmacyId = JSON.parse(profileDeeplinkData)['pharmacyId']
        }
    } else pharmacyId = reduxState.pharmacyAllData['id']
    return pharmacyId;
}

export function getChemistStoreData(chemistStoreData) {
    if (chemistStoreData &&
        chemistStoreData.length &&
        isObjectNotEmpty(JSON.parse(chemistStoreData))) {
        return {
            isStoreLoaded: checkChemistStoreDataLoaded(
                JSON.parse(chemistStoreData)),
            storeData: JSON.parse(chemistStoreData)
        }
    } else {
        return {
            isStoreLoaded: false,
            storeData: {}
        }
    }
}

export function checkChemistStoreDataLoaded(chemistStoreData) {
    let isStoreDataLoaded = false
    if (chemistStoreData &&
        isObjectNotEmpty(chemistStoreData)) {
        const arr = ['id', 'name', 'pharmacyName', 'streetAddress', 'deals'];
        isStoreDataLoaded = objectContainAllKeys(chemistStoreData, arr)
    } else isStoreDataLoaded = false
}

export const refreshChemistData = ({ storeId = 0 }) => {
    let refreshList = [{
        name: RefreshCacheAction.refreshChemistStoreData,
        requestData: { chemistStoreId: storeId }
    }]
    CacheDataToRefresh.setRefreshList(refreshList)
}

export const getStoreMaxDiscount = (storeDiscounts) => {
    var maxStoreDiscount = { 'discount': 0, mtype: '' }
    if (storeDiscounts && storeDiscounts.length) {
        storeDiscounts.forEach((discount) => {
            if (discount['discount'] > maxStoreDiscount.discount)
                maxStoreDiscount = discount
        })
        return maxStoreDiscount
    } else return maxStoreDiscount
}

export function roundOffRating(rating) {
    return Math.round(rating * 2) / 2
}

export function computeDistance(distance) {
    distance = Math.round(distance)
    if (distance < 1000)
        return distance + ' meters away'
    else return (distance / 1000).toFixed(2) + ' km away'
}

export function hasChemistProfilePic(pharmacy) {
    return pharmacy && pharmacy?.prpicVersion && pharmacy.prpicVersion > 0 ? true : false
}

export function hasChemistStorePic(pharmacy) {
    return pharmacy && pharmacy?.storePicturesV2 && pharmacy.storePicturesV2.length ? true : false
}

export function getChemistProfilePicUrl(pharmacy) {
    const reduxState = store.getState()
    const profileDummyImage = getImagePath('/images/chemistStore/profile.png')
    var gpToken = ''
    if (reduxState.isUserLogin)
        gpToken = reduxState.userToken['gpToken']
    else gpToken = reduxState.guestToken['gpToken']
    if (!gpToken || !pharmacy?.prpicVersion) return profileDummyImage
    var urn = ServiceEndpoints[getServerID()]['aayu'] + 'v2_agent_picture'
    const uri = urn + '?agentId=' + pharmacy.id.toString() + '&pictureName=profilePicture' + '&token=' + gpToken
    return uri
}

export function getChemistStorePicUrl(pharmacy) {
    const reduxState = store.getState()
    const profileDummyImage = getImagePath('/images/chemistStore/chemistStorePic.png')
    var gpToken = ''
    if (reduxState.isUserLogin)
        gpToken = reduxState.userToken['gpToken']
    else gpToken = reduxState.guestToken['gpToken']
    if (!gpToken) return profileDummyImage
    var urn = ServiceEndpoints[getServerID()]['aayu'] + 'v2_agent_picture'
    const uri = urn + '?agentId=' + pharmacy.id.toString() + '&pictureName=proofDocPStore' + '&token=' + gpToken
    console.log('###, parmid', pharmacy.id, 'uri: ', uri)
    return uri
}

export function getChemistAppLogo() {
    return window.APP_LOGO && window.APP_LOGO != '$APP_LOGO' ? window.APP_LOGO : null;
}